import apiClient from '../server';
import axios from 'axios';
export const fetchMusicTypesFilters = async (discoveryPage)=>{
    try{
        const response=await apiClient.get(`params/subSections/getByDiscoveryPage?discoveryPage=${discoveryPage}`)
        return response.data.data;
    }catch(error){
        console.error("there was an error fetching data: ",error);
    }
}
export const getAllCities = async ()=>{
    try{
        const response=await apiClient.get('/params/cities/all?pagination=false');
        return response;
    }catch(error){
        console.error("there was an error fetching data: ",error);
    }
}
export const updateCityStatus = async (cityId, cityData) => {
    try {
      const response = await apiClient.patch(`/params/cities/update/${cityId}`, cityData);
      return response.data;
    } catch (error) {
      throw new Error('Error updating city status');
    }
  };

export const updateEnabledFilter = async(discoveryPage,name) =>{
    try{
        const response=await apiClient.patch(`/params/subSections/updateByDiscoveryPage?discoveryPage=${discoveryPage}&name=${name}`)
        return response.data;
    }catch(error){ 
        throw new Error('error updating filter');
    }
}

export const checkEnabledFilter = async(discoveryPage,name)=>{
    try{
        const response=await apiClient.get(`/params/subSections/getByDiscoveryPage?discoveryPage=${discoveryPage}&name=${name}`)
        return response.data;
    }catch(error){
        throw new Error('error updating filter');
    }
}

export const getActiveCountries = async()=>{
    try{
        const response=await apiClient.get(`params/countries/all?pagination=false&isEnabled=true`)
        return response.data;
    }catch(error){
        throw new Error('error fetching cities');
    }
}